import "./index.scss";
import { LuUserRound } from "react-icons/lu";
import { IoMdNotificationsOutline } from "react-icons/io";
import { IoMailOutline, IoStatsChartSharp } from "react-icons/io5";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../../helpers";
import axios from "axios";
import {
  fetchCurrentInvoice,
  fetchInvoices,
} from "../../store/features/invoiceSlice";
import { fetchOrders } from "../../store/features/orderSlice";
import { Link } from "react-router-dom";

function Main() {
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");
  const owner = useSelector((state) => state.owner.owner);
  const { currentInvoice, invoices } = useSelector((state) => state.invoice);
  const { orders } = useSelector((state) => state.order);
  const API_URL = process.env.REACT_APP_API_URL;

  const [userInfo, setUserInfo] = useState(false);
  const [isHistoryActive, setIsHistoryActive] = useState(false);

  const dispatch = useDispatch();
  const [expenses, setExpenses] = useState([]);

  const miniItems = [
    {
      name: "За неделю",
      icon: <IoStatsChartSharp />,
      text: expenses.week || 0,
    },
    {
      name: "За текущий месяц",
      icon: <IoStatsChartSharp />,
      text: expenses.currentMonth || 0,
    },
    {
      name: "За прошлый месяц",
      icon: <IoStatsChartSharp />,
      text: expenses.lastMonth || 0,
    },
    {
      name: "За последние 3 месяца",
      icon: <IoStatsChartSharp />,
      text: expenses.treeMonth || 0,
    },
  ];

  const fetchExpenses = useCallback(async () => {
    try {
      const token = await getToken();
      if (!token) {
        console.error("Токен не найден");
        return;
      }
      const response = await axios.get(`${API_URL}/orders/user/expenses`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExpenses(response.data);
    } catch (error) {
      console.error("Ошибка при получении расходов:", error);
    }
  }, [API_URL]);

  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      fetchExpenses();
    }
  }, [token, navigate, fetchExpenses]);

  useEffect(() => {
    dispatch(fetchCurrentInvoice());
    dispatch(fetchOrders());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchInvoices());
  }, [dispatch]);

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    return isNaN(parsedDate)
      ? "Неизвестная дата"
      : parsedDate.toLocaleString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
  };

  const formatMonth = (date) => {
    const parsedDate = new Date(date);
    return isNaN(parsedDate)
      ? "Неизвестная дата"
      : parsedDate.toLocaleString("ru-RU", {
          month: "long",
          year: "numeric",
        });
  };

  return (
    <div className="main">
      <header className="header">
        <div className="header__sales">
          <p>
            Продажи за сегодня:{" "}
            <span className="header__amount">{expenses.today || 0} сом</span>
          </p>
        </div>
        <div className="header__incoices">
          <button
            className="header__sales salesBtn"
            onClick={() => setIsHistoryActive(true)}
          >
            <p>
              Сумма к оплате за текущий месяц:{" "}
              <span className="header__amount">{currentInvoice || 0} сом</span>
            </p>
          </button>
        </div>
        <div className="header__profile">
          {[IoMdNotificationsOutline, IoMailOutline].map((Icon, idx) => (
            <a href="/#" key={idx} className="header__link">
              <span className="header__notification">
                <Icon className="header__linkIcon" />
              </span>
            </a>
          ))}
          <a
            href="/#"
            className="header__link header__name"
            onClick={() => setUserInfo(!userInfo)}
          >
            {owner?.companyName || ""}
            <span className="header__linkSpan">
              <LuUserRound className="header__linkIcon" />
            </span>
          </a>
          {userInfo && (
            <div className="header__userInfo userInfo">
              <div className={`userInfo__img ${!owner.logo ? "note" : ""}`}>
                {!owner.logo ? (
                  <LuUserRound className="userInfo__icon" />
                ) : (
                  <img src={owner?.logo} alt="logo" />
                )}
              </div>
              <span className="userInfo__edit">Изменить</span>

              <div className="userInfo__content">
                <div className="userInfo__owner">
                  <p>Логин:</p>
                  <span>{owner.login}</span>
                </div>
                <div className="userInfo__owner">
                  <p>Название компании:</p>
                  <span>{owner.companyName}</span>
                </div>
                <div className="userInfo__owner">
                  <p>Телефон номер:</p>
                  <span>{owner.phoneNumber}</span>
                </div>
                {/* <div className="userInfo__owner">
                  <p>Email:</p>
                </div> */}
                <div className="userInfo__owner">
                  <p>Адрес:</p>
                  <span>{owner.address}</span>
                </div>
                <div className="userInfo__owner">
                  <p>Процентная ставка:</p>
                  <span>{owner.serviceCharge}%</span>
                </div>

                <span className="userInfo__edit">Изменить данные</span>

                <span
                  className="userInfo__close"
                  onClick={() => setUserInfo(false)}
                >
                  Закрыть
                </span>
              </div>
            </div>
          )}
        </div>
      </header>
      <main className="dashboard">
        <h2 className="dashboard__title title">Панель управления</h2>
        <section className="dashboard__items bigRowOne">
          <div className="dashboard__item dashboard__miniItems">
            {miniItems.map((miniItem, index) => (
              <div className="dashboard__miniItem miniItem" key={index}>
                <div className="miniItem__icon">{miniItem.icon}</div>
                <div className="miniItem__content">
                  <p className="miniItem__text">{miniItem.text} сом</p>
                  <p className="miniItem__title">{miniItem.name}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="dashboard__item secondItem">
            <h3 className="dashboard__orderTitle title">Последние заказы</h3>

            <ul className="dashboard__orderList">
              {!orders
                ? ""
                : orders
                    .filter((order) => order.status === "new")
                    .slice(0, 5)
                    .map((order) => (
                      <li key={order.id} className="dashboard__orderItem">
                        <p>№ {order.key}</p>
                        <p>Магазин: {order?.shop?.shopName}</p>
                        <p>{order.amount} сом</p>
                      </li>
                    ))}
              {orders.filter((order) => order.status === "new").length ===
                0 && <p>Нет новых заказов</p>}
            </ul>
            <Link to="/orders" className="dashboard__link">
              Показать все
            </Link>
          </div>
        </section>
        <section className="dashboard__items bigRowTwo">
          <div className="dashboard__item"></div>
          <div className="dashboard__item"></div>
        </section>
      </main>

      {isHistoryActive && (
        <div className="invoicesHistory">
          <div className="invoicesHistory__tableWrapper">
            <span
              className="invoicesHistory__close"
              onClick={() => setIsHistoryActive(false)}
            ></span>

            <h3 className="invoicesHistory__title">Ваши оплаты</h3>
            <div className="invoicesHistory__content">
              <table className="invoicesHistory__table">
                <thead>
                  <tr>
                    <th>Месяц</th>
                    <th>Сумма</th>
                    <th>Оплачено</th>
                    <th>Статус</th>
                    <th>Создан</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices && invoices.length > 0 ? (
                    invoices.map((invoice) => (
                      <tr key={invoice.id}>
                        <td>{formatMonth(invoice.paymentDate)}</td>
                        <td>{invoice.amount} сом</td>
                        <td>{invoice.paymentAmount} сом</td>
                        <td style={{ color: invoice.paid ? "green" : "red" }}>
                          {invoice.paid ? "Оплачен" : "Не оплачен"}
                        </td>
                        <td>{formatDate(invoice.createdAt)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">История счетов пуста</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;
